import { isCustomizedType, reduce } from "et3-type-guards";
import { ADMIN_VERSION_DEFAULT_STATES } from "../../constants/core-constants";
import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { TAdminVersionStates } from "../../Types";
import { post } from "../axios-post";

export const apiCallGetAdminVersionsStates = async ({
  version
}: {
  version: string;
}): Promise<{
  data: TAdminVersionStates;
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    isActive: boolean;
    isUnderMaintenance: boolean;
    latestAdminVersion: string;
  }>(`core/getAdminVersionStates`, { version });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: ADMIN_VERSION_DEFAULT_STATES,
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: ADMIN_VERSION_DEFAULT_STATES,
      status: "ERROR",
      code: "ERROR"
    };
  }
};
